import { render, staticRenderFns } from "./ForgotPasswordContent.vue?vue&type=template&id=0877698b&scoped=true"
import script from "./ForgotPasswordContent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877698b",
  null
  
)

export default component.exports